import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserViewportService } from './browser-viewport.service';
import { ViewportService } from '@shared/shared/viewport/common/abstract/viewport-service';

@NgModule()
export class BrowserViewportModule {
  static forRoot(): ModuleWithProviders<BrowserViewportModule> {
    return {
      ngModule: BrowserViewportModule,
      providers: [{ provide: ViewportService, useClass: BrowserViewportService }]
    };
  }
}
